module.exports = __webpack_public_path__ + "img/placeholderImg.9f173b6e.png";